import React from 'react';
import { Row, Col } from 'antd';
import StateAreaHeader from './state-area-header';
import StateAreaButtons from './state-area-buttons';

export default function StateArea({ application, offer, staffingRequest }) {
  return (
    <Row>
      <Col span={2} offset={1} />

      <Col span={20} offset={1}>
        <StateAreaHeader application={application} offer={offer} />
        <StateAreaButtons
          application={application}
          offer={offer}
          staffingRequest={staffingRequest}
        />
      </Col>
    </Row>
  );
}

StateArea.propTypes = {
  ...StateAreaHeader.propTypes,
  ...StateAreaButtons.propTypes,
};
